import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Numeral from 'numeral';

const SellingProfile = ({ ...props }) => {
  SellingProfile.propTypes = {
    row: PropTypes.number,
    opportunity: PropTypes.object,
    referral: PropTypes.object,
    property: PropTypes.object,
    userprofile: PropTypes.object
  };

  const timeFrameLabel = (props.opportunity.timeFrameInDays || props.opportunity.timeFrameInDays === 0) ? props.opportunity.timeFrame : '';
  const agentEstimatedEquityValue = props.opportunity && props.opportunity.agentEstimatedEquity;
  const hasAgentEstimatedEquity = Number.isInteger(agentEstimatedEquityValue) && agentEstimatedEquityValue > 0;
  const agentEstimatedEquityLabel = hasAgentEstimatedEquity ? `$${Numeral(agentEstimatedEquityValue).format('0,0')}` : '';
  

  const hasAreasOfInterest = props.opportunity.areasOfInterest && props.opportunity.areasOfInterest.length > 0;
  const hasTimeFrame = !!timeFrameLabel;

  return (
    <React.Fragment>
      <div className='small-sm-down' style={{ position: 'relative' }}>
        {hasAreasOfInterest &&
          <div className='d-flex justify-content-between mb-3'>
            <div>
              <strong>Location(s) of Interest</strong>
              <div>
                {props.opportunity.areasOfInterest
                  .map((location) => {
                    return location.value;
                  })
                  .join(', ')
                }
              </div>
            </div>
          </div>
        }

        {hasTimeFrame &&
          <div className='mb-3'>
            <strong>Est. Time Frame</strong>
            <div>{timeFrameLabel}</div>
          </div>
        }

        {hasAgentEstimatedEquity &&
          <div className='mb-3'>
            <strong>Agent Estimated Equity</strong>
            <div>{agentEstimatedEquityLabel}</div>
          </div>
        }

        <div className='text-muted'>
          {`Updated: ${moment(props.opportunity.timestampModified).format('MM/DD/YY')}`}
        </div>
      </div>
    </React.Fragment>
  );
};
export default SellingProfile;
